// extracted by mini-css-extract-plugin
export default {"popoverClueInfoWrapper":"PopoverClue_popoverClueInfoWrapper__BWTD1","popoverClueButton":"PopoverClue_popoverClueButton__KfD7T"};